export default "__VITE_ASSET__TrnpBgbA__"